module.exports = __webpack_public_path__ + "img/微信2.addd9f2.png";